import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { TableConfig } from "../../config/Config";
import "./index.modules.scss";

export function Pagination({ handlePageClick, offset, ...props }) {
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    setPageCount(Math.ceil(props.totalData / props.limit));
  }, [props.totalData, props.limit]);

  return (
    <div>
      <ReactPaginate
        previousLabel={<ArrowBackIosIcon style={{ fontSize: 16 }} />}
        nextLabel={<ArrowForwardIosIcon style={{ fontSize: 16 }} />}
        breakLabel={"..."}
        breakClassName={"break-me"}
        pageCount={pageCount}
        forcePage={offset - 1}
        marginPagesDisplayed={1}
        pageRangeDisplayed={TableConfig.pageRangeDisplayed}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        subContainerClassName={"pages pagination"}
        activeClassName={"active"}
      />
    </div>
  );
}
